import angular from 'angular';
import * as R from 'ramda';
import '../../sass/constants/_colors';
import ISharedModelService from './ISharedModel.service';

let _$filter;

export class riskSharedModelService extends ISharedModelService {
  constructor(
    $filter,
    // controlDataService, // eslint-disable-line no-shadow
  ) {
    super('am');
    _$filter = $filter;
    // _controlDataService = oversightDataService;

    this.riskOnsets = null;

    this.riskForewarnings = null;

    this.riskDurations = null;

    this.riskDataConfidentialities = null;

    this.riskDataIntegrities = null;

    this.riskDataAvailabilities = null;

    this.riskDirections = null;

    this.riskTrendings = null;

    this.riskAssessmentFrequencies = null;

    this.riskProbabilities = null;

    this.riskClassifications = null;

    this.probabilityColorList = {
      'Never Happens': 'fc-hula-skirt-green-100',
      'Extremely Improbable': 'fc-hula-skirt-green-100',

      Improbable: 'fc-hula-skirt-green-100',

      Unlikely: 'fc-hula-skirt-green-75',
      Remote: 'fc-hula-skirt-green-75',

      Occasional: 'fc-navanta-coral-75',

      Probable: 'fc-navanta-coral-75',

      Regular: 'fc-bankers-love-red-75',

      Frequent: 'fc-bankers-love-red-75',

      Commonplace: 'fc-bankers-love-red-100',

      Definite: 'fc-bankers-love-red-100',
    };

    console.log('app.services.oversightSharedModelService created');
  }

  /** ********************************************************************************************
   *  ********************************************************************************************
   *  ********************************************************************************************
   * CRUD Operations
   *
   */
  transformRiskTop(item) {
    if (this.RiskProbabilities) {
      item.riskProbability = this.transformProbability(item, this.RiskProbabilities);
    }
    if (this.RiskTrendings) {
      item.riskTrending = this.transformRiskTrending(item, this.RiskTrendings);
    }
    if (this.RiskDirections) {
      item.riskDirection = this.transformDirection(item, this.RiskDirections);
    }
    if (this.CustomerRiskInherentSeverityLevels) {
      // eslint-disable-next-line max-len
      item.customerRiskInherentSeverityLevel = this.transformInherentSeverity(item, this.CustomerRiskInherentSeverityLevels);
    }
  }

  transformRisk(item) {
    item.riskAssessmentFrequency = this.transformAssessmentFrequency(item, this.RiskAssessmentFrequencies);
    item.riskClassification = this.transformClassification(item, this.RiskClassifications);
    item.riskDataAvailability = this.transformDataAvailability(item, this.RiskDataAvailabilities);
    item.riskDataConfidentiality = this.transformDataConfidentiality(item, this.RiskDataConfidentialities);
    item.riskDataIntegrity = this.transformDataIntegrity(item, this.RiskDataIntegrities);
    item.riskDuration = this.transformDuration(item, this.RiskDurations);
    item.riskForewarning = this.transformForewarning(item, this.RiskForewarnings);
    item.riskOnset = this.transformRiskOnset(item, this.RiskOnsets);
  }

  transformInherentSeverity(data, propertyList) {
    let result = {};
    const find = R.find(
      R.propEq('customerRiskInherentSeverityLevelId', data.customerRiskInherentSeverityLevelId),
      propertyList
    );
    if (!find) {
      result = null;
    } else {
      result = find;
    }
    return result;
  }

  transformAssessmentFrequency(data, propertyList) {
    let result = {};
    const find = R.find(
      R.propEq('riskAssessmentFrequencyId', data.riskAssessmentFrequencyId),
      propertyList
    );
    if (!find) {
      result = null;
    } else {
      result = find;
    }
    return result;
  }

  transformClassification(data, propertyList) {
    let result = {};
    const find = R.find(
      R.propEq('riskClassificationID', data.riskClassificationID),
      propertyList
    );
    if (!find) {
      result = null;
    } else {
      result = find;
    }
    return result;
  }

  transformDataAvailability(data, propertyList) {
    let result = {};
    const find = R.find(
      R.propEq('riskDataAvailabilityId', data.riskDataAvailabilityId),
      propertyList
    );
    if (!find) {
      result = null;
    } else {
      result = find;
    }
    return result;
  }

  transformDataConfidentiality(data, propertyList) {
    let result = {};
    const find = R.find(
      R.propEq('riskDataConfidentialityId', data.riskDataConfidentialityId),
      propertyList
    );
    if (!find) {
      result = null;
    } else {
      result = find;
    }
    return result;
  }

  transformDataIntegrity(data, propertyList) {
    let result = {};
    const find = R.find(
      R.propEq('riskDataIntegrityId', data.riskDataIntegrityId),
      propertyList
    );
    if (!find) {
      result = null;
    } else {
      result = find;
    }
    return result;
  }

  transformDirection(data, propertyList) {
    let result = {};
    const find = R.find(
      R.propEq('riskDirectionId', data.riskDirectionId),
      propertyList
    );
    if (!find) {
      result = null;
    } else {
      result = find;
    }
    return result;
  }

  transformDuration(data, propertyList) {
    let result = {};
    const find = R.find(
      R.propEq('riskDurationId', data.riskDurationId),
      propertyList
    );
    if (!find) {
      result = null;
    } else {
      result = find;
    }
    return result;
  }

  transformForewarning(data, propertyList) {
    let result = {};
    const find = R.find(
      R.propEq('riskForewarningId', data.riskForewarningId),
      propertyList
    );
    if (!find) {
      result = null;
    } else {
      result = find;
    }
    return result;
  }

  transformRiskOnset(data, propertyList) {
    let result = {};
    const find = R.find(
      R.propEq('riskOnsetId', data.riskOnsetId),
      propertyList
    );
    if (!find) {
      result = null;
    } else {
      result = find;
    }
    return result;
  }

  transformProbability(data, propertyList) {
    let result = {};
    const find = R.find(
      R.propEq('riskProbabilityId', data.riskProbabilityId),
      propertyList
    );
    if (!find) {
      result = null;
    } else {
      result = find;
    }
    return result;
  }

  transformRiskTrending(data, propertyList) {
    let result = {};
    const find = R.find(
      R.propEq('riskTrendingId', data.riskTrendingId),
      propertyList
    );
    if (!find) {
      result = null;
    } else {
      result = find;
    }
    return result;
  }

  addColorToProbability(risk) {
    if (risk.riskProbability) {
      risk.probabilityColor = this.probabilityColorList[risk.riskProbability.name];
    }
    return risk;
  }

  addSeverityDescriptionsToRisks(risk) {
    if (
      risk.inherentRiskSeverityRating >= 1
      && risk.inherentRiskSeverityRating < 3
    ) {
      risk.inherentRiskSeverityRatingDescription = 'Least';
    } else if (
      risk.inherentRiskSeverityRating >= 3
      && risk.inherentRiskSeverityRating < 6
    ) {
      risk.inherentRiskSeverityRatingDescription = 'Minimal';
    } else if (
      risk.inherentRiskSeverityRating >= 6
      && risk.inherentRiskSeverityRating < 9
    ) {
      risk.inherentRiskSeverityRatingDescription = 'Moderate';
    } else if (
      risk.inherentRiskSeverityRating >= 9
      && risk.inherentRiskSeverityRating < 12
    ) {
      risk.inherentRiskSeverityRatingDescription = 'Significant';
    } else if (
      risk.inherentRiskSeverityRating >= 12
      && risk.inherentRiskSeverityRating < 15
    ) {
      risk.inherentRiskSeverityRatingDescription = 'Most';
    }
    return risk;
  }

  addSeverityDescriptionsToRiskType(riskType) {
    if (riskType.customerRiskInherentSeverityLevel) {
      if (
        riskType.customerRiskInherentSeverityLevel.riskInherentSeverityLevelId === 1
      ) {
        riskType.inherentRiskSeverityRatingDescription = 'Least';
        riskType.inherentSeverityMeterLevel = 1;
        riskType.inherentSeverityCssClass = 'status-tier-bar--great';
      } else if (
        riskType.customerRiskInherentSeverityLevel.riskInherentSeverityLevelId === 2
      ) {
        riskType.inherentRiskSeverityRatingDescription = 'Minimal';
        riskType.inherentSeverityMeterLevel = 2;
        riskType.inherentSeverityCssClass = 'status-tier-bar--good';
      } else if (
        riskType.customerRiskInherentSeverityLevel.riskInherentSeverityLevelId === 3
      ) {
        riskType.inherentRiskSeverityRatingDescription = 'Moderate';
        riskType.inherentSeverityMeterLevel = 3;
        riskType.inherentSeverityCssClass = 'status-tier-bar--caution';
      } else if (
        riskType.customerRiskInherentSeverityLevel.riskInherentSeverityLevelId === 4
      ) {
        riskType.inherentRiskSeverityRatingDescription = 'Significant';
        riskType.inherentSeverityMeterLevel = 4;
        riskType.inherentSeverityCssClass = 'status-tier-bar--bad';
      } else if (
        riskType.customerRiskInherentSeverityLevel.riskInherentSeverityLevelId === 5
      ) {
        riskType.inherentRiskSeverityRatingDescription = 'Most';
        riskType.inherentSeverityMeterLevel = 5;
        riskType.inherentSeverityCssClass = 'status-tier-bar--terrible';
      }
    } else {
      riskType.inherentRiskSeverityRatingDescription = 'None';
      riskType.inherentSeverityMeterLevel = 0;
      riskType.inherentSeverityCssClass = 'status-tier-bar--neutral';
    }
    return riskType;
  }

  addSeverityDescriptionsToRiskTypeOld(riskType) {
    if (riskType.inherentRiskSeverityRating) {
      if (
        riskType.inherentRiskSeverityRating >= 1
        && riskType.inherentRiskSeverityRating < 3
      ) {
        riskType.inherentRiskSeverityRatingDescription = 'Least';
        riskType.inherentSeverityMeterLevel = 1;
        riskType.inherentSeverityCssClass = 'status-tier-bar--great';
      } else if (
        riskType.inherentRiskSeverityRating >= 3
        && riskType.inherentRiskSeverityRating < 6
      ) {
        riskType.inherentRiskSeverityRatingDescription = 'Minimal';
        riskType.inherentSeverityMeterLevel = 2;
        riskType.inherentSeverityCssClass = 'status-tier-bar--good';
      } else if (
        riskType.inherentRiskSeverityRating >= 6
        && riskType.inherentRiskSeverityRating < 9
      ) {
        riskType.inherentRiskSeverityRatingDescription = 'Moderate';
        riskType.inherentSeverityMeterLevel = 3;
        riskType.inherentSeverityCssClass = 'status-tier-bar--caution';
      } else if (
        riskType.inherentRiskSeverityRating >= 9
        && riskType.inherentRiskSeverityRating < 12
      ) {
        riskType.inherentRiskSeverityRatingDescription = 'Significant';
        riskType.inherentSeverityMeterLevel = 4;
        riskType.inherentSeverityCssClass = 'status-tier-bar--bad';
      } else if (
        riskType.inherentRiskSeverityRating >= 12
        && riskType.inherentRiskSeverityRating < 15
      ) {
        riskType.inherentRiskSeverityRatingDescription = 'Most';
        riskType.inherentSeverityMeterLevel = 5;
        riskType.inherentSeverityCssClass = 'status-tier-bar--terrible';
      }
    } else {
      riskType.inherentRiskSeverityRatingDescription = 'None';
      riskType.inherentSeverityMeterLevel = 0;
      riskType.inherentSeverityCssClass = 'status-tier-bar--neutral';
    }
    return riskType;
  }

  transformMeterStatusToRiskType(riskType) {
    const classMappingsProbability = {
      5: 'status-tier-bar--terrible',
      4: 'status-tier-bar--bad',
      3: 'status-tier-bar--caution',
      2: 'status-tier-bar--good',
      1: 'status-tier-bar--great',
    };

    const classMappings = {
      3: 'status-tier-bar--terrible',
      2: 'status-tier-bar--bad',
      1: 'status-tier-bar--caution',
      0: 'status-tier-bar--neutral',
    };

    if (riskType.riskProbability) {
      const cssClassProbability = classMappingsProbability[riskType.riskProbability.score];
      riskType.riskProbabilityCssClass = cssClassProbability;
    }

    if (riskType.riskDataConfidentiality) {
      const cssClassConfidentiality = classMappings[riskType.riskDataConfidentiality.score];
      riskType.riskDataConfidentialityCssClass = cssClassConfidentiality;
    }

    if (riskType.riskDataIntegrity) {
      const cssClassIntegrity = classMappings[riskType.riskDataIntegrity.score];
      riskType.riskDataIntegrityCssClass = cssClassIntegrity;
    }

    if (riskType.riskDataAvailability) {
      const cssClassAvailability = classMappings[riskType.riskDataAvailability.score];
      riskType.riskDataAvailabilityCssClass = cssClassAvailability;
    }
    return riskType;
  }

  /**
   *
   * @param collection - array of object with canView property
   * @param {Object} propertyObject - Object containing the property to search and the desired value
   * @returns {Array<Object>}
   */
  filterByProperty(collection, propertyObject) {
    return _$filter('filter')(collection, propertyObject);
  }

  transformRiskTypeList(risks) {
    let riskTypeList = [];
    R.forEach(
      (item) => {
        const find = R.find(
          R.propEq('customerRiskTypeId', item.customerRiskType.customerRiskTypeId),
          riskTypeList
        );
        if (!find) {
          const newType = angular.copy(item.customerRiskType);
          newType.risks = [];
          newType.risks.push(item);
          riskTypeList.push(newType);
        } else {
          find.risks.push(item);
        }
      },
      risks
    );
    R.forEach(
      (item) => {
        item.count = item.risks.length;
        R.forEach(
          (risk) => {
            risk.count = risk.customerRiskControls.length;
          },
          item.risks
        );
      },
      riskTypeList
    );

    riskTypeList = R.sortBy(R.prop('name'), riskTypeList);
    return riskTypeList;
  }
}

riskSharedModelService.$inject = [
  '$filter',
  // 'oversightDataService',
];

export default angular.module('app.services.riskSharedModelService', [
  // oversightDataService,
])
  .service('riskSharedModelService', riskSharedModelService)
  .name;
